import type { JwtPayload } from 'jwt-decode';
import { jwtDecode } from 'jwt-decode';

/** Decodes a JWT's claims without verifying it. Returns null for a malformed token. */
export function decodeJwtPayload<T extends JwtPayload = JwtPayload>(token: string): T | null {
  // Same shape check jws applies: three base64url segments, signature may be empty.
  if (!/^[\w-]+\.[\w-]+\.[\w-]*$/.test(token)) {
    return null;
  }

  try {
    jwtDecode(token, { header: true });
    const claims = jwtDecode<T>(token);
    return typeof claims === 'object' && claims !== null ? claims : null;
  } catch {
    return null;
  }
}
